module.exports = __webpack_public_path__ + "static/media/us.12d247d7.svg";